import merge from 'lodash/merge';
import production from './production';

export default merge({}, production, {
  host: 'signin.int.ots.ai',
  favicon: 'ots_favicon.ico'
});
